import {useUser} from "../contexts/UserContext";
import {useTranslation} from "react-i18next";
import "../styleSheets/welcomeHeader.css"

type WelcomeHeaderProps = {
    variant?: "dashboard" | "panel";
    id?: string;
};
function WelcomeHeader({variant = "dashboard", id}: WelcomeHeaderProps){
    const {t} = useTranslation("common");
    const {firstName, lastName, nickname } = useUser();
    let greetingText;
    let greetingName;
    if (variant === "dashboard"){
        greetingName = `${t("common.welcomeBack")} ${nickname ?? firstName}!`;
        greetingText = t("common.greetingText");
    } else if (variant === "panel"){
        greetingName = `${firstName} ${lastName}`;
        greetingText = "";
    }
    const HeadingTag = variant === "dashboard" ? "h1" : "h2";
    return (
        <div className="section-welcome-back">
            <HeadingTag id={id} className="welcome-back-user">{greetingName}</HeadingTag>
            <div className="welcome-back-sub-text">{greetingText}</div>
        </div>
    )
}
export default WelcomeHeader;
